<template>
  <div class="container-fluid">
    <div id="brs" class="contents">
      <tab />
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-1"
          role="tabpanel"
          aria-labelledby="pills-1-tab"
        >
          <b-form @submit="onSubmit">
            <div class="row row-cols-2 row-cols-lg-4 g-2 mb-4">
              <div class="col-12 col-sm-6">
                <select
                  aria-label="search select"
                  v-model="searchData.searchtype"
                >
                  <option value="fit_as_title">
                    {{ $t("filter.common.title") }}
                  </option>
                  <option value="B.fit_brand_nm">
                    {{ $t("filter.brandroom.sort_by_goods_name") }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-sm-6">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('text.common.enter_search_term')"
                    :aria-label="$t('text.common.enter_search_term')"
                    v-model="searchData.searchname"
                  />
                  <button
                    class="btn btn-primary btn-lg icon-search"
                    type="submit"
                  ></button>
                </div>
              </div>
              <div class="col">
                <select v-model="searchData.findex">
                  <option value="tf_fit_as.reg_date">
                    {{ $t("filter.brandroom.sort_by_date") }}
                  </option>
                  <option value="B.fit_brand_nm">
                    {{ $t("filter.brandroom.sort_by_brand_name") }}
                  </option>
                  <option value="fit_as_category">
                    {{ $t("filter.brandroom.sort_by_category") }}
                  </option>
                </select>
              </div>
              <div class="col">
                <select v-model="searchData.pagesize">
                  <option value="10">
                    {{ $t("filter.common.10 per page") }}
                  </option>
                  <option value="20">
                    {{ $t("filter.common.20 per page") }}
                  </option>
                  <option value="30">
                    {{ $t("filter.common.30 per page") }}
                  </option>
                </select>
              </div>
            </div>
          </b-form>

          <table class="table board">
            <thead>
              <tr>
                <th class="col-auto d-none d-lg-table-cell w-1">
                  {{ $t("title.common.number") }}
                </th>
                <th class="col-auto d-lg-table-cell w-1">
                  {{ $t("title.common.type") }}
                </th>
                <th class="col-auto d-lg-table-cell">
                  {{ $t("title.common.title") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.status") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.brandroom.brand_name") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.date") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell w-1">
                  {{ $t("title.brandroom.view_count") }}
                </th>

                <th class="th-arrow">&nbsp;</th>
              </tr>
            </thead>
            <tbody v-if="items.length">
              <template v-for="(item, index) in items">
                <tr class="btn1" :key="index">
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ item.noticeinfo.no }}
                  </td>
                  <td class="col-auto d-lg-table-cell">
                    <span
                      class="icon badge bg-purple"
                      :class="
                        item.noticeinfo.category | get_custormer_category_bg
                      "
                      >{{ item.noticeinfo.category | get_custormer_category }}
                    </span>
                  </td>
                  <td class="col-auto d-lg-table-cell">
                    <router-link
                      :to="{
                        name: 'CustomerView',
                        params: { noticeno: item.noticeinfo.noticeno },
                        query: { category: searchData.category },
                      }"
                    >
                      {{ item.noticeinfo.title }}
                    </router-link>
                    <img
                      src="/img/icon_new.gif"
                      class="ms-1"
                      v-if="$dayjs().diff(item.timezone_date, 'day') < 8"
                    />
                  </td>
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ item.noticeinfo.status }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell brand-name">
                    {{ item.noticeinfo.brandname }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell text-date">
                    {{ item.noticeinfo.timezone_regdate | dateformat }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell text-views">
                    {{ item.noticeinfo.viewcnt | comma }}
                  </td>
                  <td class="td-arrow" @click="toggle_tr(index)">
                    <img
                      src="/img/arrow_none_collapsed.png"
                      :class="{ 'btn-toggle-arrow': view_hide === index }"
                    />
                  </td>
                </tr>
                <tr
                  class="col-auto d-lg-none d-md-tabel-cell"
                  :class="{ show: view_hide === index }"
                  :key="index + 'r'"
                  v-if="view_hide === index"
                >
                  <td colspan="7">
                    <div class="toggle-content">
                      <div class="row">
                        <div class="col-4">{{ $t("title.common.number") }}</div>
                        <div class="col-8">
                          {{ item.noticeinfo.no }}
                        </div>
                      </div>
                      <!--
                      <div class="row">
                        <div class="col-4">클럽종류</div>
                        <div class="col-8">
                          {{ item.noticeinfo.category | get_club_type }}
                        </div>
                      </div>
 -->
                      <div class="row">
                        <div class="col-4">{{ $t("title.common.status") }}</div>
                        <div class="col-8 date">
                          {{ item.noticeinfo.status }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.brandroom.brand_name") }}
                        </div>
                        <div class="col-8 brand-name">
                          {{ item.noticeinfo.brandname }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">{{ $t("title.common.date") }}</div>
                        <div class="col-8 text-date">
                          {{ item.noticeinfo.timezone_regdate | dateformat }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.brandroom.view_count") }}
                        </div>
                        <div class="col-8 text-views">
                          {{ item.noticeinfo.viewcnt | comma }}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="8" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>
          <b-pagination-nav
            :link-gen="linkGen"
            :number-of-pages="page_total"
            v-model="searchData.pageno"
            use-router
            aria-label="Page navigation example"
            v-if="page_total > 1"
            first-class="prev"
            prev-class="prev"
            next-class="next"
            last-class="next"
            hide-ellipsis
            limit="10"
          >
            <template #first-text
              ><i class="material-icons">
                keyboard_double_arrow_left</i
              ></template
            >
            <template #prev-text
              ><i class="material-icons">navigate_before</i></template
            >
            <template #next-text
              ><i class="material-icons">navigate_next</i></template
            >
            <template #last-text
              ><i class="material-icons"
                >keyboard_double_arrow_right</i
              ></template
            >
            <template #page="{ page, active }">
              <a v-if="active">{{ page }}</a>
              <a v-else>{{ page }}</a>
            </template>
          </b-pagination-nav>
        </div>
      </div>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          aria-label="등록"
          @click="
            $router.push({
              name: 'CustomerWrite',
            })
          "
          >{{ $t("button.common.write") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import location from "@/components/Location";
import tab from "@/components/fitting/NoticeTab";
import ax from "@/api/fitting";
import "@/filter/common";

export default {
  name: "CustomerList",
  components: {
    location,
    tab,
  },
  data() {
    return {
      searchData: {
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          "fit_as_title",
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        category:
          this.$route.query.category ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].category) ||
          0,

        findex: "tf_fit_as.reg_date",
        pagesize: "10",
      },

      page_total: 1,
      total_cnt: 0,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },
  methods: {
    get_custormerlist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_custormerlist(this.searchData, (flag, data) => {
        console.log(flag, data);
        this.total_cnt = data.pagination.noticelistcnt;
        this.page_total = Math.ceil(
          data.pagination.noticelistcnt / this.searchData.pagesize
        );
        this.items = data.noticelist;
        if (!flag) alert(data.message);
      });
    },
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.get_custormerlist();
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },

    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  created() {
    this.get_custormerlist();
  },
  watch: {
    "searchData.findex": function () {
      this.get_custormerlist();
    },
    "searchData.pagesize": function () {
      this.get_custormerlist();
    },
    "searchData.pagesize": function () {
      this.get_custormerlist();
    },
  },

  computed: {
    sub_menu_num: function () {
      return this.$route.meta.sub_menu_num || "";
    },
  },
};
</script>
